import React from 'react'
import './WelcomeSection.scss'
import { Button } from 'antd'
import { useSelector } from 'react-redux'
import { capitalize } from 'lodash'
import SettingsDropdown from './SettingsDropdown'
import { useTranslation } from 'react-i18next'

// No need to import GlobalLeaderboard here anymore

const WelcomeSection = ({
  activeTab,
  setActiveTab,
  onSettingsClick,
  children,
  isEmpty = false
}) => {
  const user = useSelector(state => state.user)
  const { isSuperAdmin, isAdmin } = user && user.info
  const userData = user && user.info

  const userName =
    userData && userData.first_name
      ? `${userData.first_name}`
      : userData && userData.username
        ? userData.username
        : userData && userData.email
          ? userData.email.split('@')[0]
          : 'User'
  const { t } = useTranslation()
  return (
    <div className="welcome-section">
      <div className="welcome-top">
        <div className="welcome-top__left">
          <h1 className="welcome-title">
            {t('v4:welcome_back')}, {capitalize(userName)}!
          </h1>
          <p className="welcome-subtitle">
            {t('v4:track_your_performance_and_see')}
          </p>
        </div>
        {(isSuperAdmin || isAdmin) && (
          <SettingsDropdown onSettingsClick={onSettingsClick} />
        )}
      </div>
      {!isEmpty && (
        <div className="tabs">
          <button
            className={`tab${activeTab === 'team' ? ' tab-active' : ''}`}
            onClick={() => setActiveTab('team')}
          >
            {t('v4:team_leaderboard')}
          </button>
          <button
            className={`tab${activeTab === 'global' ? ' tab-active' : ''}`}
            onClick={() => {
              setActiveTab('global')
            }}
          >
            {t('v4:global_leaderboard')}
          </button>
          <button
            className={`tab${activeTab === 'quest' ? ' tab-active' : ''}`}
            onClick={() => setActiveTab('quest')}
          >
            {t('quest:quest_leaderboard')}
          </button>
        </div>
      )}
      {children}
    </div>
  )
}

export default WelcomeSection
